import store from "../../../store"
import { setMe, setNavigateTo, setToken } from "../../../store/reducer"

const logout = () => {
    store.dispatch(setToken(null));
    store.dispatch(setMe());
    store.dispatch(setNavigateTo('/'));
}

export default logout;